/**
 * Rechtsform für E-Mail-Text entfernen.
 * „Elbrächter Elektrotechnik GmbH & Co. KG“ → „Elbrächter Elektrotechnik“
 */
const EMAIL_LEGAL_FORM_RE =
  /\s*(?:,?\s*)?(?:GmbH\s*&\s*Co\.?\s*KG|AG\s*&\s*Co\.?\s*KG|UG(?:\s*\(haftungsbeschränkt\))?|GmbH|mbH|Aktiengesellschaft|\bAG\b|\bKG\b|\bOHG\b|\boHG\b|\bGbR\b|e\.?\s*K\.?|\beK\b|e\.?\s*V\.?|\bPartG\b|\bLtd\.?\b|\bInc\.?\b|\bLLC\b|\bPLC\b|\bSE\b)\b.*$/i;

/** „UG (haftungsbeschränkt)“ → „UG“ */
const HAFTUNGSBESCHRAENKT_RE =
  /\s*[([{]?\s*haftungsbeschr(?:ä|ae)nkt\.?\s*[)\]}]?/gi;

export function stripHaftungsbeschraenkt(value) {
  let s = String(value ?? '');
  if (!s) return '';
  s = s.replace(HAFTUNGSBESCHRAENKT_RE, ' ');
  s = s.replace(/\(\s*\)/g, ' ').replace(/\[\s*\]/g, ' ');
  return s.replace(/\s+/g, ' ').trim();
}

export function stripCompanyLegalFormForEmail(value) {
  let s = String(value ?? '')
    .replace(/\s+/g, ' ')
    .trim();
  if (!s) return '';
  s = stripHaftungsbeschraenkt(s);
  s = s.replace(EMAIL_LEGAL_FORM_RE, '').trim();
  s = s.replace(/[,\s\-–—|/]+$/g, '').trim();
  return s;
}
